module.exports = __webpack_public_path__ + "img/1528063766.27478ad7.jpg";